module.exports = __webpack_public_path__ + "static/media/Marsha Queen of the Mermaids.e64bbde1.jpg";